var React = require('react');

function LinkInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","transform":"translate(1 1)"},[React.createElement("path",{"d":"M8 11a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07L9.75 3.18","key":0}),React.createElement("path",{"d":"M12 9a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71","key":1})]));
}

LinkInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = LinkInline;

LinkInline.default = LinkInline;
